module.exports = __webpack_public_path__ + "static/day02-beca37394346497984aed8ca011ecd8b.png";